import GenericModel from './generic-model';

export class Email extends GenericModel {
  type?: string;
  email?: string;
}
